<template>
    <ui-field v-bind="this.$props" v-slot="{ id }">
        <div class="flex items-end flex-wrap -m-3">
            <div v-if="preview && hasFiles" class="relative m-3">
                <div v-if="fileUrls[1]" class="absolute border border-gray-300 shadow-sm rounded-md overflow-hidden transform -rotate-6">
                    <img :src="fileUrls[1]" alt="Preview" class="w-32 h-32 object-cover">
                </div>
                <div class="relative border border-gray-300 shadow-sm rounded-md overflow-hidden">
                    <img :src="fileUrls[0]" alt="Preview" class="w-32 h-32 object-cover">
                </div>
            </div>
            <div class="flex-1 flex rounded-md shadow-sm m-3">
                <button @click.prevent="$refs.input.click()" class="z-10 -mr-px relative inline-flex flex-shrink-0 items-center space-x-3 px-4 py-2 border text-sm font-medium rounded-l-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" :class="dynamicClasses">
                    <i class="fas fa-upload text-sm text-gray-400"></i>
                    <div>Choose file</div>
                </button>
                <div class="relative rounded-r-md flex items-center w-full border sm:text-sm px-3 py-2" :class="dynamicClasses">
                    <span v-if="hasNewFiles" v-text="newFileNames"></span>
                    <span v-else class="text-gray-500" v-text="placeholder"></span>
                </div>
                <input 
                    ref="input"
                    :id="id"
                    type="file"
                    class="hidden"
                    :name="name"
                    :multiple="multiple"
                    @change="onFilesChange"
                >
            </div>
        </div>
    </ui-field>
</template>

<script>
export default {
    props: {
        value: null,
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        multiple: Boolean,
        preview: Boolean,
        current: String|Array,
        placeholder: {
            type: String,
            default: 'No file chosen...',
        },
    },
    data () {
        return {
            files: [],
        }
    },
    computed: {
        dynamicClasses () {
            if (this.error) return 'border-red-300'
            if (this.disabled) return 'border-gray-300 text-gray-500 bg-gray-50'
            return 'border-gray-300 placeholder-gray-400'
        },
        currentFiles () {
            if (! this.current) return [];
            return Array.isArray(this.current) ? this.current : [this.current]
        },
        hasCurrentFiles () {
            return this.currentFiles && this.currentFiles.length > 0
        },
        newFileNames () {
            return this.files.map(file => file.name).join(', ')
        },
        hasNewFiles () {
            return this.files && this.files.length > 0
        },
        hasFiles () {
            return this.hasNewFiles || this.hasCurrentFiles
        },
        fileUrls () {
            return this.hasNewFiles
                ? this.files.map(file => URL.createObjectURL(file))
                : this.currentFiles
        },
    },
    methods: {
        onFilesChange (event) {
            this.files = [...event.target.files]

            if (this.multiple) {
                return this.$emit('input', this.files)
            }

            this.$emit('input', this.files[0] || null)
        },
    },
    watch: {
        value (newValue) {
            if (! newValue) {
                // Clears the chosen files if the form is reset.
                this.$refs.input.value = null
                this.files = []
            }
        },
    },
}
</script>
